import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const C = motion[as];
  return (
    <C
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </C>
  );
};

export const SectionHead = ({ label, title, intro }) => (
  <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
    <div className="lg:col-span-7">
      <Reveal><p className="eyebrow flex items-center gap-3"><span className="h-px w-8 bg-signal" />{label}</p></Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-6 font-display text-4xl font-semibold leading-[0.95] tracking-[-0.03em] sm:text-5xl lg:text-7xl">{title}</h2>
      </Reveal>
    </div>
    {intro && (
      <Reveal delay={0.1} className="lg:col-span-5">
        <p className="text-base leading-relaxed text-zinc-300 sm:text-lg">{intro}</p>
      </Reveal>
    )}
  </div>
);
